import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { NavService } from './nav-service';
import { NavigatorWith2Params, PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class  InscriptionsParcoursNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition_general = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.EDITION_GENERAL,
  );

  creationBySession = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.CREATION_INSCRIPTION_BY_IDSESSION,
  );

  creationByParticipant = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.CREATION_INSCRIPTION_BY_IDPARTICIPANT,
  );

  financement = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.FINANCEMENT,
  );

  documents = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.DOCUMENTS,
  );

  modules = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.MODULES,
  );

  edition_facture_brouillon: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.FINANCEMENT,
    EparcoursPath.inscriptionsParcours.EDITION_FACTURE,
    PARAM_TOKEN,
  );

  visualise_facture_validee: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.FINANCEMENT,
    EparcoursPath.inscriptionsParcours.VISUALISE_FACTURE,
    PARAM_TOKEN,
  );

  resumeByIdInscription = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.INSCRIPTIONS_PARCOURS,
    EparcoursPath.inscriptionsParcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.inscriptionsParcours.RESUME_INSCRIPTION,
  );
}
